// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: whitesmoke;
}

/* styles.css */
.heading-box {
  text-align: left;
  background-color: #F1F1F1;
  border: solid 1px #d4d4d4;
  margin-bottom: 50px;
  background-color: #187a9b;
  color: white;
  padding: 10px;
  border-radius: 5px 5px 0 0;
  display: block;
  width: 100%;
  box-sizing: border-box;
}

.CurrentDesignee {
  border: 2px solid #286090;
  width: 100%;
  margin: 5% auto;
  border-radius: 10px;
  background-color: #fff;
  padding-bottom:2% auto;
}

.search-button {
  background-color: #187a9b;
  color: white;
  padding: 3px 15px;
  border-radius: 5px;
  cursor: pointer;
  margin-left: 10px;
}

.search-button:disabled {
  background-color: #187a9b;
  cursor: not-allowed;
}



/* General table styles */
table {
  border-collapse: collapse;
  width: 100%;

}

th,
td {
  border: 1px solid grey;
  padding: 2px;
  text-align: center;
  height: 30px;
}

th {
  background-color: #f2f2f2;
}

/* Specific styles for the nested table */
.heading-box+table {
  border: 1px solid grey;
}

.heading-box+table th,
.heading-box+table td {
  border: 1px solid grey;
  padding: 5px;
  text-align: center;
  height: 10px;
}




/* Modal styles */
.modal {
  display: none;
  position: fixed;
  z-index: 1;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: transparent;
}

.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
  max-width: 500px;
  height: auto;
  max-height: 300px;
  overflow-y: auto;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}


/* OK button styles */
#closeSuccessModal {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 5px 10px;
  text-align: right;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
  margin: 10px 0;
  cursor: pointer;
  border-radius: 4px;
  position: absolute;
  right: 20px;
  bottom: 20px;
}

#closeSuccessModal:hover {
  background-color: #0056b3;
}
.currentdesignee-select-text {
  color: white;
  padding: 10px;
  background-color: #286090;
  text-align: left;
  border-radius: 5px 5px 0 0;
}

:host {
  font-family: "GothamBold", "Helvetica Neue", Helvetica,Arial, sans-serif;
}
.designee-message {
  color: red;
  text-align: right;
  margin-top: 10px; /* Adjust as needed */
}
.table{
  padding-left: 2%;
  padding-right: 2%;
}`, "",{"version":3,"sources":["webpack://./src/app/doa/temporary-doa-designee/temporary-doa-designee.component.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;;;AAIA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,WAAW;;AAEb;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC;EACE,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;;;;AAKA,iBAAiB;AACjB;EACE,aAAa;EACb,eAAe;EACf,UAAU;EACV,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,4EAA4E;AAC9E;;;AAGA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,wEAAwE;AAC1E;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB,EAAE,qBAAqB;AACzC;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["body {\n  background-color: whitesmoke;\n}\n\n/* styles.css */\n.heading-box {\n  text-align: left;\n  background-color: #F1F1F1;\n  border: solid 1px #d4d4d4;\n  margin-bottom: 50px;\n  background-color: #187a9b;\n  color: white;\n  padding: 10px;\n  border-radius: 5px 5px 0 0;\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.CurrentDesignee {\n  border: 2px solid #286090;\n  width: 100%;\n  margin: 5% auto;\n  border-radius: 10px;\n  background-color: #fff;\n  padding-bottom:2% auto;\n}\n\n.search-button {\n  background-color: #187a9b;\n  color: white;\n  padding: 3px 15px;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-left: 10px;\n}\n\n.search-button:disabled {\n  background-color: #187a9b;\n  cursor: not-allowed;\n}\n\n\n\n/* General table styles */\ntable {\n  border-collapse: collapse;\n  width: 100%;\n\n}\n\nth,\ntd {\n  border: 1px solid grey;\n  padding: 2px;\n  text-align: center;\n  height: 30px;\n}\n\nth {\n  background-color: #f2f2f2;\n}\n\n/* Specific styles for the nested table */\n.heading-box+table {\n  border: 1px solid grey;\n}\n\n.heading-box+table th,\n.heading-box+table td {\n  border: 1px solid grey;\n  padding: 5px;\n  text-align: center;\n  height: 10px;\n}\n\n\n\n\n/* Modal styles */\n.modal {\n  display: none;\n  position: fixed;\n  z-index: 1;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: transparent;\n}\n\n.modal-content {\n  background-color: #fefefe;\n  margin: auto;\n  padding: 20px;\n  border: 1px solid #888;\n  width: 80%;\n  max-width: 500px;\n  height: auto;\n  max-height: 300px;\n  overflow-y: auto;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\n\n/* OK button styles */\n#closeSuccessModal {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 5px 10px;\n  text-align: right;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 14px;\n  margin: 10px 0;\n  cursor: pointer;\n  border-radius: 4px;\n  position: absolute;\n  right: 20px;\n  bottom: 20px;\n}\n\n#closeSuccessModal:hover {\n  background-color: #0056b3;\n}\n.currentdesignee-select-text {\n  color: white;\n  padding: 10px;\n  background-color: #286090;\n  text-align: left;\n  border-radius: 5px 5px 0 0;\n}\n\n:host {\n  font-family: \"GothamBold\", \"Helvetica Neue\", Helvetica,Arial, sans-serif;\n}\n.designee-message {\n  color: red;\n  text-align: right;\n  margin-top: 10px; /* Adjust as needed */\n}\n.table{\n  padding-left: 2%;\n  padding-right: 2%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
